import { DSNewslettersLink, LinkedLinkProps } from 'shared-definitions/types'
import { ApiNewsletterLink, ApiNewsletterDescriptor } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from './pLinkMapper'

export interface NewsletterButtonMapperOpts extends PLinkMapperOpts {
  newsletterPageLinkBuilder: (slug: string) => LinkedLinkProps
}

export function newsletterButtonMapper(
  inputLink: ApiNewsletterLink,
  inputDescriptor: ApiNewsletterDescriptor,
  opts: NewsletterButtonMapperOpts
): Omit<DSNewslettersLink, 'type'> {
  return {
    title: inputLink.title,
    subtitle: inputDescriptor.type,
    label: inputLink.label,
    pLink: opts.newsletterPageLinkBuilder(inputLink.slug),
    image: imageMapper(inputLink.image, opts),
  }
}
